import React, { Component } from 'react';
import { Editor } from '@tinymce/tinymce-react';

import content from './content';

class TextEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      content
    };
  }

  handleEditorChange = e => {
    console.log('Content was updated:', e.target.getContent());
  };

  render() {
    return (
      <Editor
        style={editorStyle}
        initialValue={content}
        init={{
          height: '50vh',
          resize: 'both',
          branding: false,
          browser_spellcheck: true,
          autoresize_overflow_padding: -50,
          plugins:
            'searchreplace textcolor colorpicker table link image media code autolink emoticons print save wordcount',
          theme_advanced_buttons3_add: 'search,replace',
          theme_advanced_buttons3_add: 'tablecontrols',
          fontsize_formats: '6 8 10 12 14 18 24 36 48 60 72',
          image_title: true,
          automatic_uploads: true,
          file_picker_types: 'image'
        }}
      />
    );
  }
}

const editorStyle = {};

export default TextEditor;



// WEBPACK FOOTER //
// ./src/components/TextEditor/index.js